module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', [_c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": "Интервенције"
    }
  })], 1), _vm._v(" "), _c('b-tabs', {
    attrs: {
      "content-class": "mt-3"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Активација фактура",
      "active": ""
    }
  }, [_c('activate-invoice')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Измирење угашене организације"
    }
  }, [_c('closed-org-settlement')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Пренос фактура"
    }
  }, [_c('move-invoices')], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-73f00188", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73f00188","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/intervention/Interventions.vue
// module id = 793
// module chunks = 1